import { render, staticRenderFns } from "./ClientRequestersTable.vue?vue&type=template&id=b5d7b93a&scoped=true&"
import script from "./ClientRequestersTable.vue?vue&type=script&lang=js&"
export * from "./ClientRequestersTable.vue?vue&type=script&lang=js&"
import style0 from "./ClientRequestersTable.vue?vue&type=style&index=0&id=b5d7b93a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d7b93a",
  null
  
)

export default component.exports